// Articles configuration
// Maps article IDs to their metadata and HTML file paths
//
// How to add a new article:
// 1. Create an HTML file in /public/articles/ folder (e.g., 002-article-name.html)
// 2. Include images in the same folder and reference them as: /articles/image-name.png
// 3. Add the article metadata below with a unique ID
// 4. The HTML file should contain only the body content (no DOCTYPE/html/head tags needed)
// 5. Use classes: article-image-wrapper, article-image, image-caption, article-sources
//
// Example HTML structure:
//   <h1>Article Title</h1>
//   <p>Content...</p>
//   <div class="article-image-wrapper">
//     <img src="/articles/image.png" alt="..." class="article-image" />
//     <p class="image-caption">Caption text</p>
//   </div>

export const articlesConfig = {
  '1': {
    title: "H1B visa reform for Engineers",
    author: "US Society of Software Engineers",
    date: "Nov 1, 2025",
    category: "Immigration",
    tags: ["Politics", "Immigration", "Reform"],
    readTime: "10 min read",
    htmlFile: "/articles/001-non-immigrant-visa.html",
    featured: true,
    excerpt: "A call for help from American tech workers who are getting discriminated, replaced, laid off and offshored due to non-immigrant visa abuse."
  },
  '2': {
    title: "The $9-an-Hour Software That Killed 346 People",
    author: "US Society of Software Engineers",
    date: "Nov 15, 2025",
    category: "Immigration",
    tags: ["Politics", "Immigration", "Safety", "Outsourcing"],
    readTime: "8 min read",
    htmlFile: "/articles/002-9-dollars-an-hour.html",
    featured: true,
    excerpt: "How Boeing's H-1B and Indian outsourcing obsession crashed the 737 MAX. The real culprit hiding in plain sight: $9-an-hour temporary coders writing life-critical flight-control software."
  },
  '3': {
    title: "The $400 Million Human Exploit: Coinbase’s Outsourced Support Breach",
    author: "US Society of Software Engineers",
    date: "May 3, 2026",
    category: "Security",
    tags: ["Security", "Outsourcing", "Breach", "Crypto"],
    readTime: "6 min read",
    htmlFile: "/articles/003-coinbase-outsourced-support-breach.html",
    featured: true,
    excerpt: "When bribed BPO support agents in India exfiltrated data for thousands of Coinbase users, the industry learned that the human layer—not the blockchain—is often the weakest link."
  }
};

// Helper function to get article by ID
export const getArticleById = (id) => {
  return articlesConfig[id] || null;
};

// Helper function to get all article IDs
export const getAllArticleIds = () => {
  return Object.keys(articlesConfig);
};

